<template>
  <a-layout style="width: 100vw">
    <a-layout-header
      class="header"
      :style="{ position: 'fixed', zIndex: 100, width: '100%' }"
    >
      <div class="head">
        <a-icon type="menu" class="mobile-menu" @click="openMenu" />
        <router-link
          style="height: 100%; display: flex; align-items: center"
          to="/"
          class="logo"
        >
          <img src="/logo.png" style="object-fit: contain; height: 100%" />
        </router-link>

        <div class="spread">
          <router-link style="color: black; cursor: pointer" to="/"
            >Home</router-link
          >

          <router-link
            style="color: black; cursor: pointer"
            to="/team"
            >Meet our team</router-link
          >

          <router-link
            to="/blog"
            style="color: black; cursor: pointer"
            >Blog </router-link
          >

          <router-link
            to="/about-teach-n-trade"
            style="color: black; cursor: pointer"
            >About Teach-n-Trade </router-link
          >

          <router-link to="contact-us">
            <a-button icon="mail">Contact Us</a-button>
          </router-link>

          <router-link to="/login">
            <a-button icon="user">Sign In</a-button>
          </router-link>
        </div>
        <router-link class="mobile-menu" to="/login"
          ><a-icon type="user"
        /></router-link>
        <a-drawer
          title="I am interested in:"
          :placement="'top'"
          :closable="false"
          :visible="visible"
          @close="onClose"
        >
          <div class="mobile-ul">

              <router-link
                style="color: black; cursor: pointer"
                to="/contact-us"
                >CONTACT US</router-link
              >

              <router-link
                style="color: black; cursor: pointer"
                to="/service-of-sunshineconnected"
                >OUR SERVICES</router-link
              >

              <router-link
                to="/about-sunshineconnected"
                style="color: black; cursor: pointer"
                >ABOUT US</router-link
              >

          </div>
        </a-drawer>
      </div>
    </a-layout-header>
    <a-layout-content
      class="bo"
      :style="{ marginTop: '6vh', background: 'white', width: '100%' }"
    >
      <slot></slot>
    </a-layout-content>
    <a-layout-footer style="text-align: center" class="footer">
      <div class="left-footer">
        <a-avatar src="/logo.png" :size="100" />
        <div style="color: white" class="icon">
          <a-icon type="linkedin" @click="goLink" />
          <a
            style="color: white"
            href="https://www.instagram.com/sunshineconnected/"
          >
            <a-icon type="instagram" />
          </a>
          <a
            style="color: white"
            href="https://www.facebook.com/sunshineconnected"
          >
            <a-icon type="facebook" />
          </a>
        </div>
      </div>

      <div class="right-footer">
        <h2>Contact Us</h2>
        <h4>
          If you have any questions or feedback about our service, please
          connect with us!
        </h4>
        <h6>Email: sunshineconnected@gmail.com</h6>
        <h6>HQ: Alberta, Canada</h6>
        <h6>Phone: 780-293-0856</h6>
        <h6>Alternate Phone: 780-934-0294</h6>
      </div>
    </a-layout-footer>
  </a-layout>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },

  methods: {
    goLink() {
      if (window) {
        window.location.href =
          "https://www.linkedin.com/company/sunshineconnected/";
      }
    },
    openMenu() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
@media only screen and (max-height: 650px) {
  .bo {
    margin-top: 65px !important ;
  }
}
.footer {
  background: #7a0d0dff !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5rem 10rem;
  gap: 5rem;
  .left-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: min-content;
    align-items: center;
    .icon {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      font-size: 2rem;
      color: black;
      align-items: center;
      justify-content: space-around;
    }
  }
  .right-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    align-items: center;

    & > * {
      color: white;
    }
  }

  h6 {
    font-size: 1.2rem;
  }
}

.header {
  height: 80px!important;
    min-height: 55px!important;
    background: linear-gradient(180deg,rgba(238,196,79,.485),#fff)!important;
    padding: 0 5rem;
  > .head {
    z-index: 10;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    > .mobile-menu {
      display: none;
      color: black;
      font-size: 2rem;
    }
    .spread {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      & > a {
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 32px;
        &:hover {
          color: white;
        }
      }
    }
  }
}
.mobile-ul {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      font-weight: 600;
      gap: 20px;
      &:hover {
        color:#f1c331;
      }
}
@media screen and (max-width: 600px) {
  .header {
    padding: 0 10px;
    .head {
      .mobile-menu {
        display: block;
      }
      .spread {
        display: none;
      }
    }
  }
  .footer {
    flex-direction: column;
    padding: 5rem;
    margin-bottom: 5rem;
  }
}

.mails {
  width: 15vw;
  height: 100%;
  display: flex;
  font-size: 1rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  color: black;
  span {
    font-size: 1rem;
  }
}
.title {
  font-family: "Quicksand", "Source Sans Pro", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: bold;
  font-size: 2rem;
  color: black;
  letter-spacing: 1px;
  margin: 0 !important;
}
</style>
